export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

// Default thumbnail image for video players
export const DEFAULT_VIDEO_THUMBNAIL_URL =
  'https://d269mfmjkd79om.cloudfront.net/videos/video_still_small.png';
